import { Typography, TypographyProps, Theme } from '@mui/material';

const Title = ({ sx, children, ...otherProps }: TypographyProps) => {
  return (
    <Typography
      variant="subtitle1"
      sx={{
        textTransform: 'capitalize',
        fontWeight: '700',
        color: (theme: Theme) => theme.palette.primary.lighter,
        lineHeight: 1,
        ...sx,
      }}
      {...otherProps}
    >
      {children}
    </Typography>
  );
};

export default Title;
